import { createSelector } from 'reselect';
import { RootState } from '~/store';

export const selectGlobal = (state: RootState) => state;

const selectorGlobal = () =>
  createSelector(selectGlobal, substate => {
    return substate.accessProfile;
  });

export default selectorGlobal;
